import styled from "styled-components";

export const StyledCircleItem = styled.div`
    width: ${(props) => props.size};
    height: ${(props) => props.size};
    border-radius: 50%;
    border: solid 1px ${(props) => props.borderColor};
    background-color: ${(props) => props.backgroundColor};
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    cursor: pointer;
    margin: 0rem 0.3rem;
`;
